<template>
  <div>

    <div>

      <b-card :title="$t('settings.engineeringOffice.list')">
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group>
              <b-form-input
                v-model="filters.search"
                :placeholder="$t('common.search')"
                @input="fetchEngineeringOffices"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group>
              <v-select
                v-model="filters.governorate_id"
                :options="governorates"
                :reduce="val => val.id"
                :get-option-label="option => option.name_ar"
                :placeholder="$t('settings.engineeringOffice.governorate_id')"
                @input="fetchEngineeringOffices"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group>
              <v-select
                v-model="filters.specialization"
                :options="specializations"
                :reduce="val => val"
                :get-option-label="option => option"
                :placeholder="$t('settings.engineeringOffice.specialization')"
                @input="fetchEngineeringOffices"
              />
            </b-form-group>
          </b-col>
        <!-- <b-col cols="12" md="4">
          <b-form-group>
            <v-select
              v-model="filters.is_active"
              :options="statusOptions"
              :reduce="val => val.value"
              :placeholder="$t('common.status')"
              @input="fetchEngineeringOffices"
            />
          </b-form-group>
        </b-col> -->

        </b-row>
        <b-button
          variant="primary"
          :to="{ name: 'settings-engineering-offices-add' }"
          class="mb-2"
        >
          {{ $t('settings.engineeringOffice.add') }}
        </b-button>
        <center v-if="loading">
          <b-spinner
            variant="primary"
            label="Spinning"
          />
        </center>
        <b-table
          v-else
          :items="engineeringOffices"
          :fields="fields"
          show-empty
          responsive="sm"
          :empty-text="$t('common.no_data')"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-1" />
              <strong>{{ $t('common.loading') }}</strong>
            </div>
          </template>
          <template #cell(actions)="data">
            <div class="d-flex justify-content-center">
              <feather-icon
                icon="EditIcon"
                size="16"
                class=" text-success"
                @click="editEngineeringOffice(data.item)"
              />
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="ml-1 text-primary"
                @click="viewEngineeringOffice(data.item)"
              />
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 text-danger"
                @click="deleteEngineeringOffice(data.item)"
              />
            </div>

          </template>
        </b-table>

      </b-card>
    </div>

  </div>
</template>

<script>
import {
  BSpinner, BFeatherIcon, BDropdown, BDropdownItem, BCard, BButton, BTable, BRow, BCol, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSpinner, BFeatherIcon, BDropdown, BDropdownItem, BCard, BButton, BTable, vSelect, BRow, BCol, BFormGroup, BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      filters: {
        search: '',
        governorate_id: null,
        is_active: null,
        specialization: null,
      },
      specializations: [
        'architecture',
        'civil',
        'mechanical',
        'electrical',
        'general',
      ],
      fields: [
        { key: 'office_name', label: this.$t('settings.engineeringOffice.office_name') },
        { key: 'registration_number', label: this.$t('settings.engineeringOffice.registration_number') },
        { key: 'specialization', label: this.$t('settings.engineeringOffice.specialization') },
        { key: 'owner_name', label: this.$t('settings.engineeringOffice.owner_name') },
        { key: 'phone', label: this.$t('settings.engineeringOffice.phone') },
        { key: 'governorate_id', label: this.$t('settings.engineeringOffice.governorate_id') },
        { key: 'license_expiry_date', label: this.$t('settings.engineeringOffice.license_expiry_date') },

        { key: 'actions', label: this.$t('common.actions') },

      ],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
    }
  },
  computed: {
    ...mapGetters({
      engineeringOffices: 'engineeringOffices/engineeringOffices',
      loading: 'engineeringOffices/load',
      governorates: 'governorates/dropdown',
    }),
  },
  mounted() {
    this.fetchEngineeringOffices()
    this.fetchGovernorates()
  },
  methods: {
    fetchEngineeringOffices() {
      const params = {
        page: this.currentPage,
        per_page: this.perPage,
        ...this.filters,
      }
      this.$store.dispatch('engineeringOffices/list', params)
    },
    fetchGovernorates() {
      this.$store.dispatch('governorates/dropdown')
    },
    clearFilters() {
      this.filters = {
        search: '',
        governorate_id: null,
        is_active: null,
        specialization: null,
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      this.fetchEngineeringOffices()
    },
    handlePerPageChange(perPage) {
      this.perPage = perPage
      this.fetchEngineeringOffices()
    },
    editEngineeringOffice(item) {
      this.$router.push({ name: 'settings-engineering-offices-edit', params: { id: item.id } })
    },
    viewEngineeringOffice(item) {
      this.$router.push({ name: 'settings-engineering-offices-view', params: { id: item.id } })
    },
    deleteEngineeringOffice(item) {
      this.$swal.fire({
        title: 'هل أنت متأكد من حذف هذا المكتب؟',
        text: 'هذا المكتب سيتم حذفه بشكل نهائي ولا يمكن التراجع عنه',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'حذف',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('engineeringOffices/delete', item.id)
            .then(() => {
              this.$swal.fire({
                title: 'تم الحذف بنجاح',
                icon: 'success',
                timer: 1500,
              })
              this.fetchEngineeringOffices()
            })
            .catch(error => {
              this.$swal.fire({
                title: error.response.data.message,
                icon: 'error',
                timer: 1500,
              })
            })
        }
      })
    },
  },
}
</script>
